import { SVGProps } from "react";

export function ArrowForward(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2833 8.66675H3.16666V7.33341H11.2833L7.54999 3.60008L8.49999 2.66675L13.8333 8.00008L8.49999 13.3334L7.54999 12.4001L11.2833 8.66675Z"
        fill="currentColor"
      />
    </svg>
  );
}
